jQuery($ => {
    class GravityForm {
        constructor(element) {
            this._ = element;
            this._element = $(element);

            this.init();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger('init', this);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
            $(document).on('gform_post_render', () => {
                this._gfield = $(".gfield");
                var $inputs = this._gfield.find("input[type='text']"),
                    $emails = this._gfield.find("input[type='email']"),
                    $phones = this._gfield.find("input[type='tel']"),
                    $urls = this._gfield.find("input[type='url']"),
                    $checkboxes = this._gfield.find("input[type='checkbox']"),
                    $radioButtons = this._gfield.find("input[type='radio']"),
                    $number = this._gfield.find("input[type='number']"),
                    $textareas = this._gfield.find("textarea"),
                    $selects = this._gfield.find("select");

                // If input or textarea has value, open it
                $inputs.each((_, element) => {
                    if ($(element).val() !== '' || $(element).attr('placeholder')) {
                        this.handleOpenInput($(element));
                    }
                });

                $emails.each((_, element) => {
                    if ($(element).val() !== '' || $(element).attr('placeholder')) {
                        this.handleOpenInput($(element));
                    }
                });

                $phones.each((_, element) => {
                    if ($(element).val() !== '' || $(element).attr('placeholder')) {
                        this.handleOpenInput($(element));
                    }
                });

                $urls.each((_, element) => {
                    if ($(element).val() !== '' || $(element).attr('placeholder')) {
                        this.handleOpenInput($(element));
                    }
                });

                $checkboxes.each((_, element) => {
                    if ($(element).val() !== '' || $(element).attr('placeholder')) {
                        this.handleOpenInput($(element));
                    }
                });

                $radioButtons.each((_, element) => {
                    if ($(element).val() !== '' || $(element).attr('placeholder')) {
                        this.handleOpenInput($(element));
                    }
                });

                $textareas.each((_, element) => {
                    if ($(element).val() !== '' || $(element).attr('placeholder')) {
                        this.handleOpenInput($(element));
                    }
                });

                $number.each((_, element) => {
                    if ($(element).val() !== '' || $(element).attr('placeholder')) {
                        this.handleOpenInput($(element));
                    }
                });

                // If input, textarea, or select focused, open it
                $inputs.focus((e) => {
                    this.handleOpenInput($(e.target));
                });

                $emails.focus((e) => {
                    this.handleOpenInput($(e.target));
                });

                $phones.focus((e) => {
                    this.handleOpenInput($(e.target));
                });

                $urls.focus((e) => {
                    this.handleOpenInput($(e.target));
                });

                $checkboxes.focus((e) => {
                    this.handleOpenInput($(e.target));
                });

                $radioButtons.focus((e) => {
                    this.handleOpenInput($(e.target));
                });

                $textareas.focus((e) => {
                    this.handleOpenInput($(e.target));
                });

                $number.focus((e) => {
                    this.handleOpenInput($(e.target));
                });

                $selects.focus((e) => {
                    this.handleOpenInput($(e.target));
                });

                // If input, textarea, or select blurred, close if has no value
                $inputs.blur((e) => {
                    this.handleMaybeCloseInput($(e.target));
                });

                $emails.blur((e) => {
                    this.handleMaybeCloseInput($(e.target));
                });

                $textareas.blur((e) => {
                    this.handleMaybeCloseInput($(e.target));
                });

                $number.blur((e) => {
                    this.handleMaybeCloseInput($(e.target));
                });

                $selects.blur((e) => {
                    this.handleMaybeCloseInput($(e.target));
                });
            });

            if ($(".gfield").length) {
                $(".gfield").on('mouseenter', (e) => {
                    $(e.target).addClass('gfield--hovered');
                }).on('mouseout', (e) => {
                    $(e.target).removeClass('gfield--hovered');
                });
            }
        }

        handleOpenInput = (element) => {
            element.closest(".gfield").addClass("gfield--focused");
        }

        handleMaybeCloseInput = (element) => {
            if (element.val() !== '') {
                element.closest(".gfield").addClass("gfield--focused").removeAttr("style");
            } else {
                element.closest(".gfield").removeClass("gfield--focused");
            }
        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.gravity_form = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].gravity_form = new GravityForm(_[i], opt);
            else
                ret = _[i].gravity_form[opt].apply(_[i].gravity_form, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.m-gravity-form').gravity_form();
});